import { Component, ChangeDetectionStrategy, Input, ViewChild, EventEmitter, Output, inject } from '@angular/core';
import { TuiDropdownOpen } from '@taiga-ui/core';
import { BaseResizableComponent } from '@src/app/modules/base';
import { PreviousRouteService } from '@src/core/services';
import { EnvService } from '@src/app/modules/env';

import { LoyaltyProgramStatus } from '../../../models';
import { LoyaltyProgramAction } from '../../../types';
import { LoyaltyProgramPermService } from '../../../services';

import { BreadcrumbItem } from './types';

@Component({
  selector: 'lp-view-header',
  templateUrl: './view-header.component.html',
  styleUrls: ['./view-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewHeaderComponent extends BaseResizableComponent {
  public readonly permService = inject(LoyaltyProgramPermService);
  private readonly env = inject(EnvService);
  private readonly previousRouteService = inject(PreviousRouteService);

  @Input() title?: string;
  @Input() breadcrumbs: BreadcrumbItem[] = [];
  @Input() status?: LoyaltyProgramStatus;
  @Input() isUserOrganisation = false;
  @Input() isExternalProduct = false;
  @Input() useUnionId = false;
  @Output() action = new EventEmitter<LoyaltyProgramAction>();

  @ViewChild(TuiDropdownOpen) component?: TuiDropdownOpen;

  showMenu = false;

  onClickBackButton() {
    this.previousRouteService.back('/loyalty');
  }

  onMenuClick(action: LoyaltyProgramAction) {
    this.showMenu = false;
    // this.component?.nativeFocusableElement?.focus();

    this.action.emit(action);
  }

  get isPublishDropdownActionVisible() {
    return !this.isExtraLargeScreen && this.allowedPublishing;
  }

  get isEditDropdownActionVisible() {
    return (this.isMobile || this.screenType === 'medium') && this.allowedEditing;
  }

  get isStatisticsDropdownActionVisible() {
    return (this.isMobile || this.screenType === 'medium') && this.allowedProductStatisticsViewing;
  }

  get isUnPublishDropdownActionVisible() {
    return this.status === 'published' && this.allowedUnpublishing;
  }

  get allowedEditing(): boolean {
    return (
      this.isNotCordova &&
      ((this.permService.allowedEditing && !this.isExternalProduct) ||
        (this.permService.allowedOnlyYourOrganisationProductEditing && this.isUserOrganisation)) &&
      this.status !== 'published'
    );
  }

  get allowedDeleting(): boolean {
    return this.permService.allowedEditing && !this.isExternalProduct;
  }

  get allowedPublishing(): boolean {
    return this.permService.allowedPublishing && this.status !== 'published' && !this.useUnionId;
  }

  get allowedUnpublishing(): boolean {
    return (
      (this.permService.allowedUnpublishing && !this.isExternalProduct) ||
      (this.permService.allowedOnlyYourOrganisationProductUnpublishing && this.isUserOrganisation)
    );
  }

  get allowedProductStatisticsViewing(): boolean {
    return (
      this.permService.allowedProductStatisticsViewing ||
      (this.permService.allowedOnlyYourProductStatisticsViewing && this.isUserOrganisation)
    );
  }

  // TODO: isNotCordova - временное решение для задачи https://redmine.tbnsoft.ru/issues/9437
  get isNotCordova() {
    return !this.env.isCordova;
  }
}
